const spacesEndpoint = process.env.REACT_APP_SPACES_ENDPOINT

export const SPACES_PUBLIC_URL = spacesEndpoint.replace(/\/$/, '');

export const IMAGE_URL_BASE = `${process.env.REACT_APP_BACKEND_URL || ''}/images`;

export const getSpacesObjectURL = (objectKey) => {
  if (!objectKey) return objectKey;
  const key = String(objectKey).replace(/^\/+/, '');
  return IMAGE_URL_BASE !== '/images' ? `${IMAGE_URL_BASE}/${key}` : `${SPACES_PUBLIC_URL}/${key}`;
};